import styled from 'styled-components';
import {dFlex, dFlexCenter, desktopMedia} from '../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';

export const container = styled.div`
    ${dFlex};
    flex-direction: column;
    gap: var(--space-lg);
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    padding-bottom: calc(var(--space-3xl) * 1.5);
`;

export const sectionTitle = styled.h2`
    margin: 0;
    font-size: ${tokens.typography.fontSize.h2};
    font-weight: ${tokens.typography.fontWeight.semibold};
    line-height: 1.2;
    color: var(--TA-color-text-default);
    white-space: nowrap;
`;

export const divider = styled.hr`
    width: 100%;
    height: 1px;
    margin: var(--space-2xl) 0;
    border: 0;
    background: var(--TA-color-border-subtle);
`;

export const toolbarDivider = styled.hr`
    width: 1px;
    height: 20px;
    background: var(--TA-color-border-subtle);
    flex-shrink: 0;
    border: none;
    margin: 0;
`;

export const previousHeader = styled.div`
    ${dFlex};
    align-items: center;
    gap: var(--space-lg);
    width: 100%;
`;

export const grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: var(--space-xl);
    align-items: stretch;
    ${desktopMedia}{ grid-template-columns: repeat(auto-fill, 216px); }
`;

export const previousGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-xl);
    align-items: stretch;
    ${desktopMedia}{ grid-template-columns: repeat(auto-fill, 181px); }
`;

export const addPillWrap = styled.div`
    ${dFlexCenter};
    ${desktopMedia}{ display: none; }
`;
